<template>
  <div class="invoice-virtual-table-wrapper">
    <!-- 表格头部 -->
    <div class="table-header-wrapper" :style="headerWrapperStyle">
      <div ref="headerScrollContainer" class="header-scroll-container" :style="headerScrollStyle">
        <table class="invoice-table">
          <thead>
            <tr>
              <!-- 左侧固定列 -->
              <th v-if="showSelectionColumn" width="55" class="fixed-left">
                <el-checkbox :value="isAllSelected" :indeterminate="isIndeterminate" @change="handleSelectAll"/>
              </th>
              <th width="60" class="fixed-left">行项</th>
              <th width="80">类型</th>
              <!-- 中间可滚动列 -->
              <th width="200">开票名称</th>
              <th width="200">规格型号</th>
              <th width="80">单位</th>
              <th width="80">数量</th>
              <th width="100">开票单价</th>
              <th width="150">开票总额(不含税)</th>
              <th width="100">税额</th>
              <th width="150">开票总额(含税)</th>
              <th width="150">折扣额(含税总额)</th>
              <th width="150">折扣税额</th>
              <th width="150">实际开票金额(含税)</th>
              <th width="150">实际税额</th>
              <th width="150">实际开票金额(不含税)</th>
              <th width="100">税率</th>
              <!-- 右侧固定列 -->
              <th width="150" class="fixed-right">税收分类名称</th>
              <th width="150" class="fixed-right">税收分类编码</th>
              <th width="100" class="fixed-right">操作</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>

    <!-- 表格内容区域 -->
    <div
        ref="bodyWrapper"
        class="table-body-wrapper"
        :style="{ height: computedHeight + 'px' }"
        @scroll="handleBodyScroll">
      <div ref="bodyScrollContainer" class="body-scroll-container" :style="{ height: computedHeight + 'px' }">
        <!-- 虚拟滚动占位 -->
        <div class="virtual-placeholder" :style="{ height: totalBodyHeight + 'px' }"/>

        <!-- 实际渲染的表格内容 -->
        <div class="virtual-content" :style="{ transform: 'translateY(' + contentOffset + 'px)' }">
          <table class="invoice-table">
            <tbody>
              <tr
                  v-for="(row, idx) in displayRows"
                  :key="row.rowKey || ('row-' + idx)"
                  :class="{ 'selected-row': selectedKeys.indexOf(row.rowKey) > -1 }">
                <!-- 左侧固定列 -->
                <td v-if="showSelectionColumn" width="55" class="fixed-left">
                  <el-checkbox
                      :value="!!selectedMap[row.rowKey]"
                      @change="(val) => handleSelect(val, row)"/>
                </td>
                <td width="60" class="fixed-left">{{row.rowIndex || getRowIndex(idx)}}</td>
                <td width="80">{{row.type || '-'}}</td>
                <!-- 中间可滚动列 -->
                <td width="200">
                  <table-input
                      v-model="row.invoiceContent"
                      :disabled="edit !== 1"
                      placeholder="请输入开票名称"
                      @change="handleInvoiceContentChange(row)"/>
                </td>
                <td width="200">
                  <table-input v-model="row.specification" :disabled="edit !== 1" placeholder="请输入规格型号"/>
                </td>
                <td width="80">
                  <table-input v-model="row.unit" :disabled="edit !== 1" placeholder="请输入"/>
                </td>
                <td width="80">
                  <table-input
                      v-model="row.quantity"
                      :disabled="edit !== 1"
                      placeholder="请输入"
                      type="number"
                      @change="handleInvoiceCountChange(row)"/>
                </td>
                <td width="100">
                  <table-input
                      v-model="row.unitPrice"
                      :disabled="edit !== 1"
                      placeholder="请输入"
                      type="number"
                      @change="handleInvoiceCountChange(row)"/>
                </td>
                <td width="150">
                  <table-input
                      v-model="row.totalNetPrice"
                      :disabled="edit !== 1"
                      placeholder="请输入"
                      type="number"
                      @blur="calculateInvoiceTotalPrice(row)"/>
                </td>
                <td width="100">
                  <table-input
                      v-model="row.totalTaxPrice"
                      :disabled="edit !== 1"
                      placeholder="请输入"
                      type="number"
                      @blur="calculateInvoiceTotalPrice(row)"/>
                </td>
                <td width="150">{{row.totalPrice || '-'}}</td>
                <td width="150">
                  <table-input
                      v-model="row.discount"
                      :disabled="edit !== 1"
                      placeholder="请输入"
                      type="number"
                      @change="calculateDiscountTaxPrice(row)"/>
                </td>
                <td width="150">
                  <table-input
                      v-model="row.discountTaxPrice"
                      :disabled="edit !== 1"
                      placeholder="请输入"
                      type="number"
                      @change="calcuteItemFinalPrice(row)"/>
                </td>
                <td width="150">{{row.finalTotalPrice || '-'}}</td>
                <td width="150">{{row.finalTotalTaxPrice || '-'}}</td>
                <td width="150">{{row.finalTotalNetPrice || '-'}}</td>
                <td width="100">
                  <table-input
                      v-model="row.taxRate"
                      :disabled="edit !== 1"
                      type="number"
                      placeholder="请输入"
                      @change="handleInvoiceTaxChange(row)"/>
                </td>
                <!-- 右侧固定列 -->
                <td width="150" class="fixed-right">
                  <template v-if="edit === 1">
                    <el-select
                        v-model="row.taxTypeCode"
                        :disabled="edit !== 1"
                        value-key="value"
                        filterable
                        remote
                        :remote-method="(query) => handleRemoteSearchTrigger(query, row)"
                        :loading="row.selectLoading"
                        placeholder="输入关键字查询"
                        @change="() => handleSelectCodeTrigger(row)">
                      <el-option
                          v-for="item in row.remoteOptions"
                          :key="item.taxTypeCode"
                          :value="item.taxTypeCode"
                          :label="item.taxTypeName"/>
                    </el-select>
                  </template>
                  <template v-else>
                    {{row.taxTypeName || '-'}}
                  </template>
                </td>
                <td width="150" class="fixed-right">{{row.taxTypeCode || '-'}}</td>
                <td width="100" class="fixed-right">
                  <el-button v-if="edit === 1 && !isEdit" type="danger" @click="handleDeleteRow(idx, row)">
                    删除
                  </el-button>
                </td>
              </tr>
              <tr v-if="!sourceData || sourceData.length === 0">
                <td :colspan="showSelectionColumn ? 21 : 20" class="empty-cell">
                  暂无数据
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 加载更多提示 -->
      <div v-if="loading" class="loading-more">
        <el-loading text="加载中..." :spinner="spinner" :background-color="'rgba(255, 255, 255, 0.8)'"/>
      </div>
      <div v-else-if="hasMore && sourceData.length > 0" class="load-more-tip">
        已加载 {{sourceData.length}} 条，滚动加载更多
      </div>
    </div>
  </div>
</template>

<script>
  import TableInput from "@/views/invoicingManagement/invoiceApplication/components/TableInput.vue";

  export default {
    name: "InvoiceDetailVirtualTable",
    components: { TableInput },
    props: {
      data: {
        type: Array,
        default: function() { return []; },
      },
      edit: {
        type: Number,
        default: 1,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      showSelection: {
        type: Boolean,
        default: true,
      },
      showAction: {
        type: Boolean,
        default: true,
      },
      bodyHeight: {
        type: Number,
        default: 500,
      },
      rowHeight: {
        type: Number,
        default: 52,
      },
      hasMore: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      softInfo: {
        type: Number,
        default: 0,
      },
    },
    data: function() {
      return {
        scrollOffset: 0,
        selectedKeys: [],
        selectedMap: {}, // 使用对象存储选中状态，提高响应式性能
        sourceData: [],
        lastScrollTime: 0,
        spinner: "el-icon-loading",
        hasVerticalScrollbar: false, // 是否显示垂直滚动条
        scrollbarWidthValue: 0, // 缓存滚动条宽度
      };
    },
    computed: {
      // 计算后的表格体高度（自适应或固定）
      computedHeight: function() {
        if (!this.sourceData || this.sourceData.length === 0) {
          return 260; // 空状态最小高度（5行）
        }
        const dataHeight = this.sourceData.length * this.rowHeight;
        // 如果数据总高度小于固定高度，则使用数据总高度（自适应）
        // 否则使用固定高度（可滚动）
        const height = dataHeight <= this.bodyHeight ? dataHeight : this.bodyHeight;
        // 确保最小高度为5行（避免表格太矮）
        const minHeight = 5 * this.rowHeight;
        return Math.max(height, minHeight);
      },
      totalBodyHeight: function() {
        return this.sourceData.length * this.rowHeight;
      },
      startIndex: function() {
        return Math.max(0, Math.floor(this.scrollOffset / this.rowHeight) - 2);
      },
      endIndex: function() {
        const visibleCount = Math.ceil(this.computedHeight / this.rowHeight);
        return Math.min(this.startIndex + visibleCount + 4, this.sourceData.length);
      },
      displayRows: function() {
        if (!this.sourceData || this.sourceData.length === 0) {
          return [];
        }
        return this.sourceData.slice(this.startIndex, this.endIndex);
      },
      contentOffset: function() {
        return this.startIndex * this.rowHeight;
      },
      isAllSelected: function() {
        if (this.sourceData.length === 0) return false;
        return this.sourceData.every(function(row) {
          return !!this.selectedMap[row.rowKey];
        }.bind(this));
      },
      isIndeterminate: function() {
        if (this.sourceData.length === 0) return false;
        let selectedCount = 0;
        for (let i = 0; i < this.sourceData.length; i++) {
          if (this.selectedMap[this.sourceData[i].rowKey]) {
            selectedCount++;
          }
        }
        return selectedCount > 0 && selectedCount < this.sourceData.length;
      },
      // 是否显示复选框（详情展示时隐藏）
      showSelectionColumn: function() {
        if (this.edit !== 1) {
          return false;
        }
        return this.showSelection;
      },
      // 获取缓存的滚动条宽度
      scrollbarWidth: function() {
        return this.scrollbarWidthValue || 0;
      },
      // 表头容器样式 - 当有垂直滚动条时添加padding-right
      headerWrapperStyle: function() {
        if (this.hasVerticalScrollbar) {
          return {
            paddingRight: this.scrollbarWidthValue + "px",
          };
        }
        return {};
      },
      // 表头滚动容器样式
      headerScrollStyle: function() {
        return {
          overflowX: "auto",
          overflowY: "hidden",
        };
      },
    },
    watch: {
      data: {
        handler: function(newVal) {
          this.sourceData = newVal || [];
          
          // 清理 selectedMap 中不再存在的行（使用 Vue.delete 确保响应式更新）
          if (this.sourceData.length === 0) {
            // 如果数据为空，清空选中状态
            this.selectedMap = {};
          } else {
            // 获取当前数据源中所有有效的 rowKey
            const validKeys = {};
            this.sourceData.forEach(function(row) {
              validKeys[row.rowKey] = true;
            });
            
            // 删除 selectedMap 中不再存在的 key
            const _this = this;
            Object.keys(this.selectedMap).forEach(function(key) {
              if (!validKeys[key]) {
                _this.$delete(_this.selectedMap, key);
              }
            });
          }
          
          // 数据变化后检测滚动条
          this.$nextTick(() => {
            this.checkVerticalScrollbar();
          });
        },
        immediate: true,
        deep: true,
      },
    },
    mounted: function() {
      this.sourceData = this.data || [];
      // 计算滚动条宽度
      this.calculateScrollbarWidth();
      // 挂载后检测滚动条
      this.$nextTick(() => {
        this.checkVerticalScrollbar();
      });
    },
    methods: {
      // 计算滚动条宽度并缓存
      calculateScrollbarWidth: function() {
        if (typeof document === "undefined") return;
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.overflow = "scroll";
        outer.style.width = "100px";
        outer.style.height = "100px";
        document.body.appendChild(outer);
        const inner = document.createElement("div");
        inner.style.width = "100%";
        inner.style.height = "100%";
        outer.appendChild(inner);
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        this.scrollbarWidthValue = scrollbarWidth || 0;
      },
      // 检测是否有垂直滚动条
      checkVerticalScrollbar: function() {
        if (this.$refs.bodyWrapper) {
          const target = this.$refs.bodyWrapper;
          const hasScroll = target.scrollHeight > target.clientHeight;
          if (this.hasVerticalScrollbar !== hasScroll) {
            this.hasVerticalScrollbar = hasScroll;
          }
        }
      },
      handleBodyScroll: function(e) {
        const target = e.target;
        this.scrollOffset = target.scrollTop;

        // 同步表头横向滚动
        if (this.$refs.headerScrollContainer) {
          this.$refs.headerScrollContainer.scrollLeft = target.scrollLeft;
        }

        // 滚动加载更多数据（防抖处理）
        this.handleLoadMore(target);
      },
      handleLoadMore: function(target) {
        const now = Date.now();
        if (now - this.lastScrollTime < 300) {
          return;
        }
        this.lastScrollTime = now;

        const scrollHeight = target.scrollHeight;
        const scrollTop = target.scrollTop;
        const clientHeight = target.clientHeight;

        // 判断是否滚动到底部（距离底部100px内触发）
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          if (this.hasMore && !this.loading) {
            this.$emit("load-more");
          }
        }
      },
      handleSelect: function(val, row) {
        const key = row.rowKey;
        // 使用 Vue.set 确保响应式更新
        this.$set(this.selectedMap, key, val);
        this.$emit("selection-change", this.getSelectedRows());
      },
      handleSelectAll: function(val) {
        const _this = this;
        this.sourceData.forEach(function(row) {
          _this.$set(_this.selectedMap, row.rowKey, val);
        });
        this.$emit("selection-change", this.getSelectedRows());
      },
      getRowIndex: function(idx) {
        return this.startIndex + idx + 1;
      },
      getOriginalIndex: function(idx) {
        return this.startIndex + idx;
      },
      getSelectedRows: function() {
        const _this = this;
        return this.sourceData.filter(function(row) { return !!_this.selectedMap[row.rowKey]; });
      },
      clearSelection: function() {
        this.selectedMap = {};
        this.$emit("selection-change", []);
      },
      // 清理已删除行的选中状态（供父组件调用）
      cleanInvalidSelection: function() {
        if (this.sourceData.length === 0) {
          this.selectedMap = {};
        } else {
          const validKeys = {};
          this.sourceData.forEach(function(row) {
            validKeys[row.rowKey] = true;
          });
          const _this = this;
          Object.keys(this.selectedMap).forEach(function(key) {
            if (!validKeys[key]) {
              _this.$delete(_this.selectedMap, key);
            }
          });
        }
      },
      // 开票数量和开票单价改变时，对应开票金额，税额，及最终开票金额等进行联动
      handleInvoiceCountChange: function(row) {
        if (!row.quantity || !row.unitPrice) {
          row.totalPrice = "";
          row.totalNetPrice = "";
          row.totalTaxPrice = "";
          this.calcuteItemFinalPrice(row);
          return;
        }
        row.totalPrice = (parseFloat(row.quantity) * parseFloat(row.unitPrice)).toFixed(2);
        row.totalNetPrice = (parseFloat(row.totalPrice) / parseFloat(1 + row.taxRate / 100)).toFixed(2);
        row.totalTaxPrice = (parseFloat(row.totalPrice) - parseFloat(row.totalNetPrice)).toFixed(2);
        this.calcuteItemFinalPrice(row);
        this.emitTaxValidate(row);
      },
      // 开票总额(不含税) / 税额改变时，对应开票金额税额进行联动
      calculateInvoiceTotalPrice: function(row) {
        this.emitTaxValidate(row);
        if (!row.totalNetPrice || !row.totalTaxPrice) {
          row.totalPrice = "";
          this.calcuteItemFinalPrice(row);
          return;
        }
        row.totalPrice = (parseFloat(row.totalTaxPrice) + parseFloat(row.totalNetPrice)).toFixed(2);
        this.calcuteItemFinalPrice(row);
      },
      // 计算折扣税额
      calculateDiscountTaxPrice: function(row) {
        const discount = parseFloat(row.discount) || 0;
        const taxRate = parseFloat(row.taxRate) || 0;
        const taxRateDecimal = taxRate / 100;
        row.discountNetPrice = parseFloat(discount / (1 + taxRateDecimal)).toFixed(2);
        row.discountTaxPrice = parseFloat(discount - row.discountNetPrice).toFixed(2);
        this.calcuteItemFinalPrice(row);
      },
      // 计算开票明细中的实际税额
      calcuteItemFinalPrice: function(row) {
        const discount = parseFloat(row.discount) || 0;
        const totalPrice = parseFloat(row.totalPrice) || 0;
        const totalNetPrice = parseFloat(row.totalNetPrice) || 0;
        const discountNetPrice = parseFloat(row.discountNetPrice) || discount / (1 + row.taxRate / 100);
        row.finalTotalPrice = (totalPrice + discount).toFixed(2);
        row.finalTotalNetPrice = (totalNetPrice + discountNetPrice).toFixed(2);
        row.finalTotalTaxPrice = parseFloat(row.finalTotalPrice - row.finalTotalNetPrice).toFixed(2);
        if (isNaN(row.finalTotalPrice)) row.finalTotalPrice = 0;
        if (isNaN(row.finalTotalTaxPrice)) row.finalTotalTaxPrice = 0;
        if (isNaN(row.finalTotalNetPrice)) row.finalTotalNetPrice = 0;
        this.$emit("data-change", row);
      },
      // 税率改变时，对应税额 折扣税额进行联动
      handleInvoiceTaxChange: function(row) {
        row.totalNetPrice = (row.totalPrice / (1 + row.taxRate / 100)).toFixed(2);
        row.totalTaxPrice = (row.totalPrice - row.totalNetPrice).toFixed(2);
        this.calculateDiscountTaxPrice(row);
        this.emitTaxValidate(row);
      },
      // 开票名称改变时处理软著信息
      handleInvoiceContentChange: function(row) {
        if (this.softInfo === 1) {
          if (row.softInfo && !row.invoiceContent.includes(row.softInfo)) {
            row.invoiceContent = row.invoiceContent + "(" + row.softInfo + ")";
          }
        }
      },
      // 处理删除行
      handleDeleteRow: function(idx, row) {
        const originalIndex = this.getOriginalIndex(idx);
        this.$emit("delete-row", originalIndex, "detail", row);
      },
      // 触发远程搜索事件
      handleRemoteSearchTrigger: function(query, row) {
        this.$emit("handle-remote-search", query, row);
      },
      // 触发选择编码事件
      handleSelectCodeTrigger: function(row) {
        this.$emit("select-code", row);
      },
      // 校验并向外抛出税额校验结果，同时直接提示用户
      emitTaxValidate: function(row) {
        const msg = this.validateTaxAmount(row);
        if (msg) {
          this.$message.warning(msg);
          this.$emit("tax-validate-error", row, msg);
        }
      },
      /**
       * 校验单行税额：|不含税金额 × 税率% - 税额| 是否超过 0.06 容差
       * @param {Object} row - 行数据
       * @param {number} rowIndex - 可选，行号（如未传入则使用 row.rowKey 推算）
       * @returns {string|null} 校验失败返回错误信息，通过返回 null
       */
      validateTaxAmount: function(row) {
        const totalNetPrice = parseFloat(row.totalNetPrice);
        const taxRate = parseFloat(row.taxRate);
        const totalTaxPrice = parseFloat(row.totalTaxPrice);

        // 如果关键字段为空，跳过校验
        if (isNaN(totalNetPrice) || isNaN(taxRate) || isNaN(totalTaxPrice)) {
          return null;
        }

        const calculatedTax = totalNetPrice * (taxRate / 100);
        const diff = Math.abs(calculatedTax - totalTaxPrice);

        if (diff > 0.06) {
          const content = row.invoiceContent || "-";
          return "开票明细 行号【" + row.rowIndex + "】 品名：【" + content + "】 不含税金额【" + totalNetPrice + "】*税率 - 税额【" + totalTaxPrice + "】 大于0.06";
        }
        return null;
      },
      /**
       * 校验所有行的税额
       * @returns {Array} 返回包含 {row, rowIndex, message} 的错误数组，空数组表示全部通过
       */
      validateAllTaxAmounts: function() {
        const errors = [];
        const _this = this;
        this.sourceData.forEach(function(row, index) {
          const msg = _this.validateTaxAmount(row, index + 1);
          if (msg) {
            errors.push({ row: row, message: msg });
          }
        });
        return errors;
      },
    },
  };
</script>

<style lang="scss" scoped>
.invoice-virtual-table-wrapper {
  width: 100%;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 600px;
  /* 最大高度限制 */
}

/* 表头区域 - 模仿 el-table */
.table-header-wrapper {
  flex-shrink: 0;
  overflow: hidden;
  background: #fafafa;
  /* el-table 表头背景色 */
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}

.header-scroll-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  /* 隐藏滚动条但保持滚动功能 */
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  /* Firefox */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* 表体区域 */
.table-body-wrapper {
  flex: 1;
  overflow: auto;
  position: relative;
  max-height: 600px;
  /* 最大高度限制 */

  /* 自定义滚动条样式 - 模仿 el-table */
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #909399;
  }

  &::-webkit-scrollbar-track {
    background: #fafafa;
    border-radius: 3px;
  }
}

.body-scroll-container {
  position: relative;
}

/* 虚拟滚动占位 */
.virtual-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  pointer-events: none;
}

/* 虚拟滚动内容 */
.virtual-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transition: transform 0.05s ease-out;
}

/* 表格样式 - 模仿 el-table */
.invoice-table {
  width: 100%;
  min-width: 2800px;
  border-collapse: collapse;
  /* 改为collapse以匹配el-table的边框 */
  border: 1px solid #ebeef5;
  /* 添加表格边框 */
  background: #fff;
  table-layout: fixed;
  font-size: 12px;

  th {
    padding: 8px 0;
    text-align: center;
    background-color: #f4f7fa !important;
    /* el-table 表头背景色 */
    font-weight: 500;
    /* el-table 表头字体粗细 */
    color: #444;
    /* el-table 表头文字颜色 */
    border-right: 1px solid #ebeef5;
    /* 添加右边框 */
    border-bottom: 1px solid #ebeef5;
    white-space: nowrap;
    position: relative;
    box-sizing: border-box;

    /* 添加单元格内边距 */
    &>div {
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /* 最后一列去掉右边框 */
    &:last-child {
      border-right: none;
    }
  }

  td {
    padding: 6px 0;
    /* el-table 单元格内边距 */
    text-align: center;
    border-right: 1px solid #ebeef5;
    /* 添加右边框 */
    border-bottom: 1px solid #ebeef5;
    vertical-align: middle;
    background: #fff;
    height: 49px;
    /* el-table 行高 */
    line-height: 23px;
    white-space: nowrap;
    position: relative;
    box-sizing: border-box;

    /* 添加单元格内边距 */
    &>div,
    &>span,
    &>.el-input,
    &>.el-select {
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      box-sizing: border-box;
      vertical-align: middle;
    }

    /* 最后一列去掉右边框 */
    &:last-child {
      border-right: none;
    }
  }

  /* 斑马纹效果 - 模仿 el-table stripe */
  tr:nth-child(even) td {
    background-color: #fafafa;
  }

  tr:hover td {
    background-color: #f5f7fa;
    /* el-table hover 背景色 */
  }

  .selected-row td {
    background-color: #ecf5ff;
    /* el-table 选中行背景色 */
  }

  /* 确保hover和选中状态的优先级 */
  tr:hover.selected-row td {
    background-color: #ecf5ff;
  }

  .empty-cell {
    text-align: center;
    padding: 40px 10px;
    color: #909399;
    font-size: 14px;
    border-right: none;
  }

  .fixed-left {
    position: sticky;
    left: -1px;
    z-index: 10;
    background-color: #fafafa;
    border-right: 1px solid #ebeef5 !important;
    /* 强制显示右边框 */
  }

  .fixed-left+.fixed-left {
    left: 55px;
  }

  .fixed-left+.fixed-left+.fixed-left {
    left: 115px;
  }

  .fixed-right {
    position: sticky;
    right: 277.5px;
    z-index: 10;
    background-color: #fafafa;
    border-left: 1px solid #ebeef5 !important;
    /* 强制显示左边框 */
  }

  .fixed-right+.fixed-right {
    right: 110.5px;
  }

  .fixed-right+.fixed-right+.fixed-right {
    right: 0;
  }

  /* 最后一行去掉底边框 - 模仿 el-table */
  tr:last-child td {
    border-bottom: none;
  }
}

/* 加载提示 */
.loading-more {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: rgba(255, 255, 255, 0.9);
  text-align: center;
  z-index: 5;
}

.load-more-tip {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  background: #fafafa;
  text-align: center;
  color: #909399;
  font-size: 12px;
  z-index: 5;
}
</style>